import { useTheme } from "@mui/material/styles";
import AppBarStyled from "./AppBarStyled";
import useIsMobileDevice from "../../../hooks/useIsMobileDevice";


const DashboardHeader = ({ children, isHeaderVisible = true }) => {
    const theme = useTheme();
    const isMobile = useIsMobileDevice();

    const appBar = {
        position: "fixed",
        color: "inherit",
        elevation: 0,
        sx: {
            display: isHeaderVisible ? "flex" : "none",
            borderBottom: `1px solid ${theme.palette.divider}`,
            ...(isMobile && {
                marginTop: "57px",
                zIndex: 500,
            }),
        },
    };

    return (
        <AppBarStyled open={true} {...appBar}>
            {children}
        </AppBarStyled>
    );
};

export default DashboardHeader;
